import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import uniqueId from 'lodash/uniqueId';
import { branchShape, childrenShape } from '@bibliocommons/bc-prop-types';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Dropdown } from '@bibliocommons/base-dropdown';
import './BranchDropdown.scss';

export default class BranchDropdown extends BcReactComponent {
  constructor(props) {
    super(props);
    this.id = uniqueId('branch-dropdown-');
  }

  getSelectedBranchName() {
    return this.props.branches
      .filter((branch) => branch.get('code') === this.props.selectedBranchCode)
      .first()
      .get('name');
  }

  getOptionsForDropdown() {
    return this.props.branches.map((branch) => ({
      label: branch.get('name', ''),
      value: branch.get('code', '')
    })).toIndexedSeq().toJS();
  }

  render() {
    return (
      <div className="cp-branch-dropdown">
        <label id={`${this.id}-label`} htmlFor={this.id}>
          {this.props.children}
        </label>
        <Dropdown
          selected={this.getSelectedBranchName()}
          disabled={this.props.disabled}
          dropdownMenuId={this.id}
          labelledById={`${this.id}-label`}
          options={this.getOptionsForDropdown()}
          isLoading={this.props.isLoading}
          className={this.props.buttonClassName}
          ButtonTag={this.props.ButtonTag}
          handleSelect={this.props.handleSelect}
          testId="single-click-holds-location"
          renderTrigger={this.props.renderDropdownTrigger} />
      </div>
    );
  }
}

BranchDropdown.propTypes = {
  children: childrenShape,
  branches: ImmutablePropTypes.listOf(branchShape),
  handleSelect: PropTypes.func,
  selectedBranchCode: PropTypes.string,
  ButtonTag: PropTypes.oneOfType([
    PropTypes.instanceOf(BcReactComponent),
    PropTypes.func
  ]),
  buttonClassName: PropTypes.string,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  renderDropdownTrigger: PropTypes.func
};

BranchDropdown.defaultProps = {
  buttonClassName: 'btn-block'
};



// WEBPACK FOOTER //
// ./app/components/shared/BranchDropdown/BranchDropdown.jsx